export const ACTION_AFFICHAGE = 'actionAffichage';
export const ACTION_INSTRUCTION_POSE = 'instructionPose';
export const ACTION_LAISSER_EN_PLACE = 'laisserEnPlace';
export const ACTION_ENLEVER_LAISSER_EN_PLACE = 'enleverLaisserEnPlace';
export const ACTION_AFFECTER_LISTE_AFFICHAGE = 'affecterListeAffichage';

export const AFFICHAGE = 'Affichage';
export const LAISSER_EN_PLACE_VENTE = 'LaisserEnPlaceVente';
export const MANUEL = 'Manuel';
export const LAISSER_EN_PLACE = 'LaisserEnPlace';

export const AUCUN = 'Aucun';

export const EXPORT_EXCEL_FACE_DISPONIBLE = 'facesdisponibles';
export const EXPORT_EXCEL_AFFECTATION_LOGISTIQUE = 'affectationlogistique';
